import { Auth } from 'aws-amplify';
import axios from 'axios';
const httpClient = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
});
const usersUrl = `/users`;
const newUsersUrl = `/users-v2`;
const bffUrl = `/bff`;
const newBffUrl = `/bff-v2`;
const documentsUrl = `/docs`;
const newDocumentsUrl = `/docs-v2`;
const dashboardUrl = `/dashboard`;
const newDashboardUrl = `/dashboard-v2`;
const configurationUrl = `/config`;
const newConfigurationUrl = `/config-v2`;
httpClient.interceptors.request.use(async (config) => {
    const user = await Auth.currentAuthenticatedUser();
    const idToken = user.signInUserSession.idToken.jwtToken;
    config.headers.Authorization = idToken;
    config.url = config.url?.startsWith(usersUrl)
        ? config.url.replace(usersUrl, newUsersUrl)
        : config.url;
    config.url = config.url?.startsWith(bffUrl)
        ? config.url.replace(bffUrl, newBffUrl)
        : config.url;
    config.url = config.url?.startsWith(documentsUrl)
        ? config.url.replace(documentsUrl, newDocumentsUrl)
        : config.url;
    config.url = config.url?.startsWith(dashboardUrl)
        ? config.url.replace(dashboardUrl, newDashboardUrl)
        : config.url;
    config.url = config.url?.startsWith(configurationUrl)
        ? config.url.replace(configurationUrl, newConfigurationUrl)
        : config.url;
    return config;
}, async (error) => Promise.reject(error));
httpClient.interceptors.response.use((response) => {
    // Parse stringified body from Lambda integration responses
    if (response.data && typeof response.data.body === 'string') {
        try {
            response.data.body = JSON.parse(response.data.body);
        }
        catch {
            // Keep original string if parsing fails (e.g., non-JSON string responses)
        }
    }
    return response;
}, async (error) => {
    if (error.response?.status === 401) {
        await Auth.signOut();
        await Auth.federatedSignIn();
    }
    return Promise.reject(error);
});
export default httpClient;
